module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4ArsE"))).then(() => parcelRequire('9Lwss'));